module.exports = __webpack_public_path__ + "img/down.19e977c0.svg";